import { render, staticRenderFns } from "./ChatbotsUserPermissionManagement.vue?vue&type=template&id=0ea19ee0&lang=pug"
import script from "./ChatbotsUserPermissionManagement.vue?vue&type=script&lang=js"
export * from "./ChatbotsUserPermissionManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ea19ee0')) {
      api.createRecord('0ea19ee0', component.options)
    } else {
      api.reload('0ea19ee0', component.options)
    }
    module.hot.accept("./ChatbotsUserPermissionManagement.vue?vue&type=template&id=0ea19ee0&lang=pug", function () {
      api.rerender('0ea19ee0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/chatbots/modules/ChatbotsUserPermissionManagement.vue"
export default component.exports